import { typeof as _typeof } from '../../../_virtual/_rollupPluginBabelHelpers.js';

/* eslint-disable @typescript-eslint/no-explicit-any */

// g-icon = goggle icon, mui = material-ui

function isIconProps(subject) {
  return _typeof(subject) === 'object' && 'icon' in subject;
}

export { isIconProps };
//# sourceMappingURL=types.esm.js.map
